import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaTable } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import api from '../../services/api';
import { temRamoFarmaceutico, temRamoNaoFarmaceutico } from '../../util/util';
import '../../css/financeiro-parcela-pagar.css';

export default function EventoRelatorioParticipante({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const nomeEmpresa = localStorage.getItem("nomeEmpresa");
    const [checkTodos, setCheckTodos] = useState({ todos: 'sim' });
    const token = localStorage.getItem('token');
    const idUsuario = localStorage.getItem("idUsuario");
    const nomeUsuario = localStorage.getItem("nomeUsuario");
    const perfil = localStorage.getItem("perfil");
    let { state } = useLocation();
    const [dadosEvento, setDadosEvento] = useState({});
    const [campos, setCampos] = useState({
        nomeOriginal: 'sim',
        crachaNome: 'sim',
        tipoparticipante: 'sim',
        idconvidado: 'sim',
        especialidade: 'sim',
        crm: 'sim',
        crmOriginal: 'sim',
        conselho: 'sim',
        conselhouf: 'sim',
        cargoparticipante: 'sim',
        instituicao: 'sim',
        socio: 'sim',
        telefone: 'sim',
        celular: 'sim',
        email: 'sim',
        datanascimento: 'sim',
        cpf: 'sim',
        rg: 'sim',
        passaporte: 'sim',
        passaportevencimento: 'sim',
        enderecologradouro: 'sim',
        enderecocep: 'sim',
        enderecobairro: 'sim',
        aereomunicipioembarque: 'sim',
        enderecomunicipionome: 'sim',
        enderecomunicipiouf: 'sim',
        produto: 'sim',
        ordeminterna: 'sim',
        gerentecomercial: 'sim',
        gerentedistrital: 'sim',
        gerentedistritalemail: 'sim',
        representante: 'sim',
        representanteemail: 'sim',
        representantetelefone: 'sim',
        vinculoOrgaoPublico: 'sim',
        bagagemDespachada: 'sim',
        assinaturaCartaConvite: 'sim',
        inscricao: 'sim',
        hotelhospedagem: 'sim',
        hotelnome: 'sim',
        hotelobservacao: 'sim',
        aereo: 'sim',
        pendenciadocumentosentradapais: 'sim',
        aereoida: 'sim',
        aereoidaobservacao: 'sim',
        aereoretorno: 'sim',
        aereoretornoobservacao: 'sim',
        transfer: 'sim',
        transferobservacao: 'sim',
        transferextra: 'sim',
        transferextraobservacao: 'sim',
        situacaoevento: 'sim',
        observacao: 'sim',
        presentenoevento: 'sim',
        inscricaonumero: 'sim',
        tipoinscricao: 'sim',
        dataopcaoaereo: 'sim',
        datacartaconvite: 'sim',
        datacartaassinada: 'sim',
        datacartainformativa: 'sim',
        dataconfirmacaocartainformativa: 'sim',
        datacertificado: 'sim',
    });

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/evento/' + id,
                token: token,
            }).then(response => { //extrai dados internos para o array principal
                var dadosRecebidos = response.data.data;
                setDadosEvento(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        }
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    const checkboxes = [
        { key: 'nomeOriginal', label: 'Nome Original' },
        { key: 'crachaNome', label: 'Nome Crachá' },
        { key: 'tipoparticipante', label: 'Tipo' },
        { key: 'idconvidado', label: 'ID' },
        { key: 'especialidade', label: 'Especialidade' },
        { key: 'crm', label: 'CRM' },
        { key: 'crmOriginal', label: 'CRM Original' },
        { key: 'conselho', label: 'Dados do Conselho' },
        { key: 'conselhouf', label: 'Estado do Conselho' },
        { key: 'cargoparticipante', label: 'Cargo' },
        { key: 'instituicao', label: 'Instituição' },
        { key: 'socio', label: 'Sócio' },
        { key: 'telefone', label: 'Telefone' },
        { key: 'celular', label: 'Celular' },
        { key: 'email', label: 'E-mail' },
        { key: 'datanascimento', label: 'Data de Nascimento' },
        { key: 'cpf', label: 'CPF' },
        { key: 'cpfAssinatura', label: 'CPF na assinatura' },
        { key: 'rg', label: 'RG' },
        { key: 'passaporte', label: 'Passaporte' },
        { key: 'passaportevencimento', label: 'Vencimento Passaporte' },
        { key: 'enderecologradouro', label: 'Endereço' },
        { key: 'enderecocep', label: 'CEP' },
        { key: 'enderecobairro', label: 'Bairro' },
        { key: 'enderecomunicipionome', label: 'Cidade' },
        { key: 'enderecomunicipiouf', label: 'Estado' },
        { key: 'produto', label: 'Produto' },
        { key: 'ordeminterna', label: 'Ordem Interna' },
        { key: 'gerentecomercial', label: 'Gerente Comercial' },
        { key: 'gerentedistrital', label: 'Gerente Distrital' },
        { key: 'gerentedistritalemail', label: 'E-mail Ger. Distr.' },
        { key: 'representante', label: 'Representante' },
        { key: 'representanteemail', label: 'E-mail Representante' },
        { key: 'representantetelefone', label: 'Telefone Representante' },
        { key: 'vinculoOrgaoPublico', label: 'Vínculo Órgão Público' },
        { key: 'assinaturaCartaConvite', label: 'Assinatura Carta Convite' },
        { key: 'inscricao', label: 'Inscrição' },
        { key: 'hotelhospedagem', label: 'Hospedagem' },
        { key: 'hotelnome', label: 'Hotel' },
        { key: 'hotelobservacao', label: 'Obs. de Hospedagem' },
        { key: 'aereo', label: 'Aéreo' },
        { key: 'bagagemDespachada', label: 'Bagagem Despachada' },
        { key: 'pendenciadocumentosentradapais', label: 'Pendência Doc. Entrada País' },
        { key: 'aereomunicipioembarque', label: 'Cidade Embarque' },
        { key: 'aereoida', label: 'Dados Aéreo (Ida)' },
        { key: 'aereoidaobservacao', label: 'Obs. de Aéreo (Ida)' },
        { key: 'aereoretorno', label: 'Dados Aéreo (Retorno)' },
        { key: 'aereoretornoobservacao', label: 'Obs. de Aéreo (Retorno)' },
        { key: 'transfer', label: 'Transfer' },
        { key: 'transferobservacao', label: 'Obs. de Transfer' },
        { key: 'transferextra', label: 'Transfer Extra' },
        { key: 'transferextraobservacao', label: 'Obs. de Transfer Extra' },
        { key: 'situacaoevento', label: 'Status' },
        { key: 'observacao', label: 'Observação' },
        { key: 'presentenoevento', label: 'Presente no evento' },
        { key: 'necessidadeespecial', label: 'Necessidade Especial' },
        { key: 'inscricaonumero', label: 'Número Inscrição' },
        { key: 'tipoinscricao', label: 'Tipo de Inscrição' },
        { key: 'dataopcaoaereo', label: 'Opção Aéreo' },
        { key: 'datacartaconvite', label: 'Data Carta Convite' },
        { key: 'datacartaassinada', label: 'Data Aceite Convite' },
        { key: 'datacartainformativa', label: 'Data Carta Informativa' },
        { key: 'dataconfirmacaocartainformativa', label: 'Data Confirmação Carta Informativa' },
        { key: 'datacertificado', label: 'Data Certificado' },
    ];

    // O ramo não farmacêutico não tem CRM, conselho nem especialidade — e é o único que tem Cargo; o
    // evento "Ambos" tem os dois. Esconder o checkbox não basta: o campo continuaria 'sim' no payload
    // e o Excel renderizaria a coluna, então os escondidos vão como 'nao' no envio.
    const camposDoOutroRamo = [
        ...(temRamoFarmaceutico(dadosEvento) ? [] : ['especialidade', 'crm', 'crmOriginal', 'conselho', 'conselhouf']),
        ...(temRamoNaoFarmaceutico(dadosEvento) ? [] : ['cargoparticipante']),
    ];
    const checkboxesVisiveis = checkboxes.filter(({ key }) => !camposDoOutroRamo.includes(key));
    const camposParaEnvio = { ...campos };
    camposDoOutroRamo.forEach((key) => { camposParaEnvio[key] = 'nao'; });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">Relatório de Participantes</h2>
                        {dadosEvento.nome ? <p className="fin-pp__subtitle">{dadosEvento.nome}</p> : null}
                    </div>
                </div>

                <div className="fin-pp__card" style={{ padding: '16px 20px' }}>
                    {/* Checkbox TODOS */}
                    <div style={{ marginBottom: 12 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontWeight: 600 }}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                style={{ margin: 0 }}
                                value={checkTodos.todos}
                                checked={checkTodos.todos === "sim"}
                                onChange={() => {
                                    checkTodos.todos = checkTodos.todos === "nao" ? "sim" : "nao";
                                    Object.keys(campos).forEach(key => {
                                        campos[key] = checkTodos.todos;
                                    });
                                    setCampos({ ...campos });
                                    setCheckTodos({ ...checkTodos });
                                }}
                            />
                            TODOS
                        </label>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 0', marginBottom: 20 }}>
                        {checkboxesVisiveis.map(({ key, label }) => (
                            <div key={key} style={{ width: '16.666%', minWidth: 140, paddingRight: 8 }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        style={{ margin: 0 }}
                                        value={campos[key]}
                                        checked={campos[key] === "sim"}
                                        onChange={() => {
                                            campos[key] = (campos[key] ?? "nao") === "nao" ? "sim" : "nao";
                                            setCampos({ ...campos });
                                        }}
                                    />
                                    {label}
                                </label>
                            </div>
                        ))}
                    </div>

                    <div>
                        <form
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/evento/exportarParticipantesExcel"}
                            target="_blank"
                            style={{ lineHeight: 0 }}
                        >
                            <input type="hidden" name="data" value={JSON.stringify({ token, campos: camposParaEnvio, idEvento: id })} />
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm">
                                <FaTable size={14} style={{ marginRight: 6 }} /> Gerar Relatório
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
